export class ResetPasswordCommand {
    public email: string;
}
